import { z } from 'zod'
import { baseSchema } from './base'

/**
 * 描述列表组件，用于展示一组描述信息
 * 接受的数据类型
 * {
 *   label: string | number
 *   value: string | number
 * }[]
 */

export const descriptionsSchema = baseSchema
  .extend({
    type: z.literal('descriptions'),
    title: z.string().optional().describe('标题'),
    dataIndex: z.string().optional().describe('JMESPath'),
    dataSource: z.any().optional().describe('数据源'),
    column: z.number().optional().describe('列数'),
  })

  .describe('描述列表组件，用于展示一组描述信息')

export type DescriptionsSchema = z.infer<typeof descriptionsSchema>
